import React from 'react';
import {DataForPreviewDto} from "../../../editor/spots/rightContent/flyerPages/FramesScreenRightPanel";
import {Box, Skeleton, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {AsyncImageWithLoader} from "../../../../com/imageWithLoader/imageWithLoader";
import {ReactComponent as CameraIcon} from "../../../../assets/camera_icon.svg";

const useStyles = makeStyles(() => ({
    previewContentWrapper: {
        display: `flex`,
        flex: `1 1 auto`,
        flexFlow: `column`,
        justifyContent: `space-between`,
        padding: `10px 15px`,
        "& > .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: `inherit`,
        },
    }
}))

interface Props {
    previewUrlData: DataForPreviewDto;
    is360iframe?: boolean;
}

export const ImagePreviewPopup: React.FC<Props> = ({
                                                       previewUrlData,
                                                       is360iframe= false
                                                   }) => {
    const classes = useStyles();
    return (
        <Box sx={{
            display: `flex`,
            width: "100%",
            maxHeight: "100%",
            flexFlow: `column`,
            backgroundColor: "#e4e4e430",
        }}>
            <Box
                sx={{
                    display: `flex`,
                    flex: `1 1 auto`,
                    height: "85%",
                    width: "100%",
                    justifyContent: "center",
                    padding: "4px",
                    // background: `url(${previewUrlData?.url}) center center / contain no-repeat rgb(225, 232, 237)`,
                }}
            >
                <Box sx={{
                    maxHeight: `100%`,
                    maxWidth: "100%",
                    minWidth: "100%",
                    border: "1px solid #e4e4e480",
                    backgroundColor: "#ffffff",
                    padding: "4px",
                }}>
                    {
                        !is360iframe &&
                        <>
                            {
                                previewUrlData?.url !== "" &&
                                <AsyncImageWithLoader src={previewUrlData?.url || ""}
                                                      withBorders={true}
                                                      notUploadIcon={(<CameraIcon style={{padding: "20%"}}/>)}/>
                            }
                            {
                                previewUrlData?.url === "" &&
                                <Skeleton
                                    animation="wave"
                                    variant="rectangular"
                                    sx={{
                                        display: `flex`,
                                        flex: `0 0 40%`,
                                        height: `100%`,
                                    }}
                                />
                            }
                        </>
                    }
                    {
                        is360iframe &&
                        <iframe
                            // src={videoPopup.frameLink}
                            src={previewUrlData.url}
                            allowFullScreen
                            allow="encrypted-media;"
                            style={{
                                border: 0,
                                height: "100%",
                                width: "100%"
                            }}
                        ></iframe>

                    }
                </Box>
            </Box>
            {
                previewUrlData?.title &&
                <Box
                    className={classes.previewContentWrapper}
                >
                    <Typography
                        fontWeight={700}
                        textAlign={"center"}
                        sx={{
                            display: "-webkit-box",
                            "WebkitLineClamp": 2,
                            "WebkitBoxOrient": "vertical"
                        }}
                    >
                        {previewUrlData?.title}
                    </Typography>
                </Box>
            }
        </Box>
    )
}